export enum MubiLeasingEnum {
  DataHasBeenSend = 'Dane zostały\nprzekazane do agenta!',
  ExpertWillContactPart1 = 'W ciągu najbliższych 48 godzin skontaktuje się z Tobą nasza ',
  ExpertWillContactPart2 = '. Pokaże Ci i porówna dostępne oferty ubezpieczenia, aby pomóc Ci wybrać najlepszą opcję.',
  ExpertZosia = 'ekspertka Zosia',
  FillDataForAnotherCar = 'Uzupełnij dane kolejnego pojazdu',
  MoreCars = 'Masz więcej pojazdów?',
  NeedUrgentContact = 'Potrzebujesz pilnego kontaktu? Zadzwoń do nas:',
  ThankForYourInterestInOurOffer = 'Dziękujemy za zainteresowanie ofertą Mubi.',
  WeWillContactYouToPresentOffers = 'Skontaktujemy się pod podany numer telefonu, aby przedstawić Ci oferty.',
}
